// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__FimxZ"};